import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NewsList.css';

const NewsList = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        try {
            // Replace this URL with your actual backend API endpoint
            const response = await fetch('http://localhost:8080/api/news');

            if (!response.ok) {
                throw new Error('Failed to fetch news');
            }

            const data = await response.json();
            setNews(data);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);

            // For demonstration purposes, use mock data if API fails
            setNews([
                {
                    id: 1,
                    title: 'Welcome to Your News Site',
                    summary: 'This is a demo news article. Replace the API endpoint with your backend service.',
                    date: '2025-11-30',
                    author: 'Admin'
                },
                {
                    id: 2,
                    title: 'Getting Started',
                    summary: 'Configure your backend API endpoint in NewsList.js to fetch real news data.',
                    date: '2025-11-29',
                    author: 'System'
                },
                {
                    id: 3,
                    title: 'Sample News Article',
                    summary: 'This is another sample article to demonstrate the news list layout.',
                    date: '2025-11-28',
                    author: 'Editor'
                }
            ]);
        }
    };

    if (loading) {
        return <div className="news-loading">Loading news...</div>;
    }

    return (
        <div className="news-list-container">
            <h1>Latest News</h1>
            {error && (
                <div className="news-error">
                    <p>Note: Using demo data. Configure your backend API endpoint at: <code>http://localhost:8080/api/news</code></p>
                </div>
            )}
            <div className="news-grid">
                {news.map((article) => (
                    <Link
                        to={`/news/${article.id}`}
                        key={article.id}
                        className="news-card"
                    >
                        <div className="news-card-content">
                            <h2>{article.title}</h2>
                            <p className="news-meta">
                                <span className="news-date">{article.date}</span>
                                {article.author && (
                                    <span className="news-author"> • By {article.author}</span>
                                )}
                            </p>
                            <p className="news-summary">{article.summary}</p>
                            <span className="read-more">Read more →</span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default NewsList;
